import ArrowDownSvg from '@/assets/ArrowDownSvg.svg';
import React from 'react';
import { AiOutlineInfoCircle } from 'react-icons/ai';

interface EmailConfirmationMobileProps {
  content?: React.ReactNode;
  image: React.ReactNode;
  message: React.ReactNode;
  subMessage?: React.ReactNode;
}

const DialogMobile: React.FC<EmailConfirmationMobileProps> = ({
  content,
  image,
  message,
  subMessage,
}) => {
  return (
    <div className="flex flex-column w-full justify-center bg-white mt-10">
      <div className="bg-body-secondary py-[16px] px-3 shadow-lg z-10 relative mb-5">
        <div className="flex flex-col gap-m ">
          <AiOutlineInfoCircle size="32" />
          <p className="display-3 text-primary">{message}</p>
          {content && <p className="lead">{content}</p>}
          {subMessage && <span>{subMessage}</span>}
        </div>
        <img
          alt="arrow-down"
          className="w-14 absolute -z-10 -bottom-10 left-1/2 transform -translate-x-1/2"
          src={ArrowDownSvg}
        />
      </div>
      {image}
    </div>
  );
};

export default DialogMobile;
